export interface Cafe {
  id: string;
  name: string;
  area: string;
  address: string;
  lat: number;
  lng: number;
  rating: number;
  reviewCount: number;
  priceMin: number;
  priceMax: number;
  openTime: string;
  closeTime: string;
  isOpen: boolean;
  photos: string[];
  vibeTags: string[];
  wifi: boolean;
  wifiSpeed: 'Kencang' | 'Sedang' | 'Lambat';
  outlet: boolean;
  parking: boolean;
  noiseLevel: 'Tenang' | 'Sedang' | 'Ramai';
  petFriendly: boolean;
  coffeeType: string;
  ratingKopi: number;
  ratingAtmosfer: number;
  ratingWifi: number;
  ratingWFH: number;
  ratingEstetik: number;
  description: string;
}

export const MOCK_CAFES: Cafe[] = [
  {
    id: 'cafe-001',
    name: 'De Bergstad',
    area: 'Klojen',
    address: 'Jl. Merbabu No. 7, Oro-oro Dowo, Klojen',
    lat: -7.9666,
    lng: 112.6326,
    rating: 4.8,
    reviewCount: 342,
    priceMin: 25000,
    priceMax: 100000,
    openTime: '10:00',
    closeTime: '01:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&q=80',
      'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=800&q=80',
      'https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=800&q=80',
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80',
    ],
    vibeTags: ['Classy', 'Fancy', 'Date Night', 'Photobooth'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Sedang',
    petFriendly: false,
    coffeeType: 'Specialty',
    ratingKopi: 4.9,
    ratingAtmosfer: 4.8,
    ratingWifi: 4.5,
    ratingWFH: 3.8,
    ratingEstetik: 4.9,
    description: 'Cafe classy dengan konsep vintage Eropa. Ada photobooth kece dan area indoor/outdoor yang instagramable banget.',
  },
  {
    id: 'cafe-002',
    name: 'Cafe Oemah Bapak',
    area: 'Dau',
    address: 'Jl. Raya Sengkaling No. 2, Sengkaling, Mulyoagung, Dau',
    lat: -7.9250,
    lng: 112.5830,
    rating: 4.6,
    reviewCount: 218,
    priceMin: 25000,
    priceMax: 50000,
    openTime: '10:00',
    closeTime: '23:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?w=800&q=80',
      'https://images.unsplash.com/photo-1521017432531-fbd92d768814?w=800&q=80',
      'https://images.unsplash.com/photo-1442512595331-e89e73853f31?w=800&q=80',
    ],
    vibeTags: ['Homey', 'WFH', 'Cozy', '3 Lantai'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Tenang',
    petFriendly: false,
    coffeeType: 'Manual Brew',
    ratingKopi: 4.5,
    ratingAtmosfer: 4.7,
    ratingWifi: 4.8,
    ratingWFH: 4.9,
    ratingEstetik: 4.4,
    description: 'Cafe homey 3 lantai, cocok banget buat WFC seharian. WiFi kencang, banyak colokan, suasana tenang.',
  },
  {
    id: 'cafe-003',
    name: 'Nukcha Matcha Cafe',
    area: 'Blimbing',
    address: 'Courtyard The Araya, Jl. Green Boulevard No. 01 Level 2, Purwodadi, Blimbing',
    lat: -7.9330,
    lng: 112.6580,
    rating: 4.7,
    reviewCount: 189,
    priceMin: 29000,
    priceMax: 100000,
    openTime: '10:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1536304993881-ff86e0c9ef82?w=800&q=80',
      'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=800&q=80',
      'https://images.unsplash.com/photo-1464306076886-debca5e8a6b0?w=800&q=80',
    ],
    vibeTags: ['Matcha', 'Aesthetic', 'Bingsoo', 'Premium'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Sedang',
    petFriendly: false,
    coffeeType: 'Matcha Bar',
    ratingKopi: 4.6,
    ratingAtmosfer: 4.8,
    ratingWifi: 4.4,
    ratingWFH: 4.2,
    ratingEstetik: 4.9,
    description: 'Matcha bar pertama di Malang dengan konsep Japanese aesthetic. Wajib coba bingsoo dan matcha latte-nya!',
  },
  {
    id: 'cafe-004',
    name: 'Zocco Heritage Coffee',
    area: 'Klojen',
    address: 'Jl. Raya Lawang–Malang No. 34, Purwantoro, Klojen',
    lat: -7.9560,
    lng: 112.6290,
    rating: 4.5,
    reviewCount: 156,
    priceMin: 25000,
    priceMax: 100000,
    openTime: '07:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=800&q=80',
      'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=800&q=80',
      'https://images.unsplash.com/photo-1498804103079-a6351b050096?w=800&q=80',
    ],
    vibeTags: ['Klasik', 'Cozy', 'Smoothies', 'Heritage'],
    wifi: true,
    wifiSpeed: 'Sedang',
    outlet: true,
    parking: true,
    noiseLevel: 'Tenang',
    petFriendly: true,
    coffeeType: 'Specialty',
    ratingKopi: 4.8,
    ratingAtmosfer: 4.6,
    ratingWifi: 3.9,
    ratingWFH: 4.1,
    ratingEstetik: 4.5,
    description: 'Nuansa heritage klasik dengan koleksi kopi specialty dari berbagai daerah Indonesia. Smoothies bowl-nya the best!',
  },
  {
    id: 'cafe-005',
    name: 'Zumma Coffee',
    area: 'Pakis',
    address: 'Jl. Wendit Utara No. 10, Mangliawan, Pakis, Kab. Malang',
    lat: -7.9880,
    lng: 112.7150,
    rating: 4.9,
    reviewCount: 421,
    priceMin: 20000,
    priceMax: 100000,
    openTime: '07:30',
    closeTime: '23:30',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1445116572660-236099ec97a0?w=800&q=80',
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80',
      'https://images.unsplash.com/photo-1511920170033-f8396924c348?w=800&q=80',
      'https://images.unsplash.com/photo-1565299507177-b0ac66763828?w=800&q=80',
    ],
    vibeTags: ['Unik', 'Berkuda', 'Playground', 'Roasting'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Ramai',
    petFriendly: true,
    coffeeType: 'Self-Roasted',
    ratingKopi: 4.9,
    ratingAtmosfer: 4.9,
    ratingWifi: 4.3,
    ratingWFH: 3.5,
    ratingEstetik: 4.8,
    description: 'Pengalaman unik: kopi roasting sendiri, playground, dan bisa berkuda! Hidden gem paling epic di Malang.',
  },
  {
    id: 'cafe-006',
    name: 'Croco by Monsieur Spoon',
    area: 'Blimbing',
    address: 'Jl. Green Boulevard No. 1, Purwodadi, Blimbing',
    lat: -7.9320,
    lng: 112.6570,
    rating: 4.6,
    reviewCount: 203,
    priceMin: 25000,
    priceMax: 100000,
    openTime: '10:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=800&q=80',
      'https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?w=800&q=80',
      'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=800&q=80',
    ],
    vibeTags: ['WFH', 'Pastry', 'Banyak Colokan', 'Modern'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Sedang',
    petFriendly: false,
    coffeeType: 'Espresso Based',
    ratingKopi: 4.6,
    ratingAtmosfer: 4.5,
    ratingWifi: 4.7,
    ratingWFH: 4.8,
    ratingEstetik: 4.6,
    description: 'WFC paradise! Banyak colokan, WiFi super kencang, dan pastry enak dari Monsieur Spoon. Favorit para remote worker.',
  },
  {
    id: 'cafe-007',
    name: 'Forenoon Coffee',
    area: 'Blimbing',
    address: 'Jl. Lkr. Blimbing Indah, Pandanwangi, Blimbing',
    lat: -7.9200,
    lng: 112.6500,
    rating: 4.4,
    reviewCount: 134,
    priceMin: 25000,
    priceMax: 125000,
    openTime: '06:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1525610553991-2bede1a236e2?w=800&q=80',
      'https://images.unsplash.com/photo-1506619216599-9d16d0903dfd?w=800&q=80',
    ],
    vibeTags: ['WFH', 'Nusantara', 'Early Bird', 'Luas'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Tenang',
    petFriendly: false,
    coffeeType: 'Manual Brew',
    ratingKopi: 4.5,
    ratingAtmosfer: 4.3,
    ratingWifi: 4.6,
    ratingWFH: 4.7,
    ratingEstetik: 4.2,
    description: 'Buka pagi jam 6! Menu nusantara yang unik dan kopi manual brew berkualitas. Cocok buat morning person.',
  },
  {
    id: 'cafe-008',
    name: 'Kismo Coffee House',
    area: 'Lowokwaru',
    address: 'Jl. Baiduri Sepah No. 4, Tlogomas, Lowokwaru',
    lat: -7.9440,
    lng: 112.6130,
    rating: 4.7,
    reviewCount: 287,
    priceMin: 23000,
    priceMax: 125000,
    openTime: '07:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=800&q=80',
      'https://images.unsplash.com/photo-1507914372368-b2b085b925a1?w=800&q=80',
      'https://images.unsplash.com/photo-1493857671505-72967e2e2760?w=800&q=80',
    ],
    vibeTags: ['Mewah', 'Aesthetic', 'Cozy', 'Premium'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Tenang',
    petFriendly: false,
    coffeeType: 'Specialty',
    ratingKopi: 4.8,
    ratingAtmosfer: 4.7,
    ratingWifi: 4.5,
    ratingWFH: 4.4,
    ratingEstetik: 4.8,
    description: 'Cafe mewah dengan interior premium yang bikin betah. Kopi specialty-nya top tier, pelayanan ramah.',
  },
  {
    id: 'cafe-009',
    name: 'Warung Kopi Ijen',
    area: 'Klojen',
    address: 'Jl. Ijen No. 15, Gading Kasri, Klojen',
    lat: -7.9700,
    lng: 112.6200,
    rating: 4.3,
    reviewCount: 98,
    priceMin: 15000,
    priceMax: 45000,
    openTime: '08:00',
    closeTime: '23:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1518057111178-44a106bad636?w=800&q=80',
      'https://images.unsplash.com/photo-1504627298434-2b9ac0f2f441?w=800&q=80',
    ],
    vibeTags: ['Santai', 'Budget', 'Nongkrong', 'Local'],
    wifi: true,
    wifiSpeed: 'Sedang',
    outlet: false,
    parking: false,
    noiseLevel: 'Ramai',
    petFriendly: true,
    coffeeType: 'Kopi Tubruk',
    ratingKopi: 4.3,
    ratingAtmosfer: 4.1,
    ratingWifi: 3.5,
    ratingWFH: 3.0,
    ratingEstetik: 3.8,
    description: 'Warung kopi legendaris di kawasan Ijen. Harga murah, suasana ramai khas warung kopi Malang.',
  },
  {
    id: 'cafe-010',
    name: 'Filosofi Kopi Malang',
    area: 'Klojen',
    address: 'Jl. Semeru No. 32, Oro-oro Dowo, Klojen',
    lat: -7.9650,
    lng: 112.6280,
    rating: 4.5,
    reviewCount: 176,
    priceMin: 30000,
    priceMax: 80000,
    openTime: '09:00',
    closeTime: '22:00',
    isOpen: false,
    photos: [
      'https://images.unsplash.com/photo-1453614512568-c4024d13c247?w=800&q=80',
      'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=800&q=80',
    ],
    vibeTags: ['Tenang', 'Literasi', 'Buku', 'Cozy'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: false,
    noiseLevel: 'Tenang',
    petFriendly: false,
    coffeeType: 'Pour Over',
    ratingKopi: 4.7,
    ratingAtmosfer: 4.6,
    ratingWifi: 4.4,
    ratingWFH: 4.5,
    ratingEstetik: 4.5,
    description: 'Terinspirasi dari film Filosofi Kopi. Nuansa literasi yang kental, koleksi buku, dan kopi pour over terbaik.',
  },
  {
    id: 'cafe-011',
    name: 'Kopi Kenangan Matos',
    area: 'Lowokwaru',
    address: 'Malang Town Square Lt. 1, Jl. Veteran, Lowokwaru',
    lat: -7.9380,
    lng: 112.6150,
    rating: 4.2,
    reviewCount: 312,
    priceMin: 20000,
    priceMax: 55000,
    openTime: '10:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=800&q=80',
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80',
    ],
    vibeTags: ['Cepat', 'Affordable', 'To-Go', 'Mall'],
    wifi: true,
    wifiSpeed: 'Sedang',
    outlet: false,
    parking: true,
    noiseLevel: 'Ramai',
    petFriendly: false,
    coffeeType: 'Espresso Based',
    ratingKopi: 4.0,
    ratingAtmosfer: 3.8,
    ratingWifi: 3.5,
    ratingWFH: 2.8,
    ratingEstetik: 4.0,
    description: 'Kopi kekinian yang affordable dan enak. Perfect buat grab and go atau nongkrong singkat di mall.',
  },
  {
    id: 'cafe-012',
    name: 'Anomali Coffee Malang',
    area: 'Klojen',
    address: 'Jl. Kawi No. 24, Bareng, Klojen',
    lat: -7.9720,
    lng: 112.6340,
    rating: 4.6,
    reviewCount: 245,
    priceMin: 35000,
    priceMax: 90000,
    openTime: '08:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=800&q=80',
      'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=800&q=80',
    ],
    vibeTags: ['Specialty', 'Tenang', 'WFH', 'Barista'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Tenang',
    petFriendly: false,
    coffeeType: 'Single Origin',
    ratingKopi: 4.9,
    ratingAtmosfer: 4.5,
    ratingWifi: 4.6,
    ratingWFH: 4.7,
    ratingEstetik: 4.4,
    description: 'Brand kopi specialty terkemuka. Koleksi single origin dari seluruh Indonesia dengan barista terlatih.',
  },
  {
    id: 'cafe-013',
    name: 'Kopi Soe Blimbing',
    area: 'Blimbing',
    address: 'Jl. Ahmad Yani No. 88, Blimbing',
    lat: -7.9150,
    lng: 112.6450,
    rating: 4.3,
    reviewCount: 167,
    priceMin: 18000,
    priceMax: 50000,
    openTime: '07:00',
    closeTime: '23:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1497935586351-b67a49e012bf?w=800&q=80',
      'https://images.unsplash.com/photo-1519452635265-7b1fbfd1e4e0?w=800&q=80',
    ],
    vibeTags: ['Minimalis', 'Kekinian', 'Affordable', 'Hangout'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: false,
    noiseLevel: 'Sedang',
    petFriendly: false,
    coffeeType: 'Espresso Based',
    ratingKopi: 4.2,
    ratingAtmosfer: 4.3,
    ratingWifi: 4.4,
    ratingWFH: 4.0,
    ratingEstetik: 4.3,
    description: 'Kopi minimalis kekinian dengan harga terjangkau. Tempat favorit anak muda Blimbing.',
  },
  {
    id: 'cafe-014',
    name: 'Janji Jiwa Lowokwaru',
    area: 'Lowokwaru',
    address: 'Jl. Soekarno Hatta No. 5, Lowokwaru',
    lat: -7.9490,
    lng: 112.6100,
    rating: 4.1,
    reviewCount: 289,
    priceMin: 15000,
    priceMax: 40000,
    openTime: '08:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1560023907-5f339617ea30?w=800&q=80',
      'https://images.unsplash.com/photo-1562802378-063ec186a863?w=800&q=80',
    ],
    vibeTags: ['Budget', 'Cepat', 'Kekinian', 'Grab & Go'],
    wifi: false,
    wifiSpeed: 'Lambat',
    outlet: false,
    parking: false,
    noiseLevel: 'Ramai',
    petFriendly: false,
    coffeeType: 'Espresso Based',
    ratingKopi: 4.0,
    ratingAtmosfer: 3.7,
    ratingWifi: 2.5,
    ratingWFH: 2.2,
    ratingEstetik: 3.9,
    description: 'Kopi kekinian yang selalu rame. Harganya murah banget buat kantong mahasiswa. Cocok buat grab and go.',
  },
  {
    id: 'cafe-015',
    name: 'Tanamera Coffee',
    area: 'Klojen',
    address: 'Jl. Bandung No. 7, Penanggungan, Klojen',
    lat: -7.9630,
    lng: 112.6310,
    rating: 4.7,
    reviewCount: 198,
    priceMin: 40000,
    priceMax: 110000,
    openTime: '09:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80',
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80',
    ],
    vibeTags: ['Premium', 'Quiet', 'WFH', 'Specialty'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: true,
    noiseLevel: 'Tenang',
    petFriendly: false,
    coffeeType: 'Specialty',
    ratingKopi: 4.9,
    ratingAtmosfer: 4.7,
    ratingWifi: 4.7,
    ratingWFH: 4.8,
    ratingEstetik: 4.6,
    description: 'Kopi specialty premium dengan biji pilihan dari Sumatra dan Sulawesi. Suasana tenang, ideal untuk kerja.',
  },
  {
    id: 'cafe-016',
    name: 'Fore Coffee UB',
    area: 'Lowokwaru',
    address: 'Jl. Veteran No. 10, Ketawanggede, Lowokwaru',
    lat: -7.9400,
    lng: 112.6170,
    rating: 4.3,
    reviewCount: 221,
    priceMin: 22000,
    priceMax: 60000,
    openTime: '08:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1511920170033-f8396924c348?w=800&q=80',
      'https://images.unsplash.com/photo-1517701604599-bb29b565090c?w=800&q=80',
    ],
    vibeTags: ['Mahasiswa', 'Affordable', 'Hangout', 'Modern'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: false,
    noiseLevel: 'Sedang',
    petFriendly: false,
    coffeeType: 'Espresso Based',
    ratingKopi: 4.2,
    ratingAtmosfer: 4.1,
    ratingWifi: 4.3,
    ratingWFH: 4.0,
    ratingEstetik: 4.2,
    description: 'Favorit mahasiswa UB dan UM. Harga terjangkau, lokasi strategis, WiFi kencang untuk tugas kuliah.',
  },
  {
    id: 'cafe-017',
    name: 'Kopi Nako Sukun',
    area: 'Sukun',
    address: 'Jl. S. Supriadi No. 45, Ciptomulyo, Sukun',
    lat: -8.0050,
    lng: 112.6180,
    rating: 4.4,
    reviewCount: 143,
    priceMin: 20000,
    priceMax: 65000,
    openTime: '09:00',
    closeTime: '23:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=800&q=80',
      'https://images.unsplash.com/photo-1498804103079-a6351b050096?w=800&q=80',
    ],
    vibeTags: ['Aesthetic', 'Instagramable', 'Hangout', 'Colorful'],
    wifi: true,
    wifiSpeed: 'Sedang',
    outlet: true,
    parking: true,
    noiseLevel: 'Sedang',
    petFriendly: false,
    coffeeType: 'Espresso Based',
    ratingKopi: 4.3,
    ratingAtmosfer: 4.5,
    ratingWifi: 3.8,
    ratingWFH: 3.6,
    ratingEstetik: 4.7,
    description: 'Cafe estetik dengan interior colorful yang instagramable. Perfect buat foto OOTD sambil ngopi.',
  },
  {
    id: 'cafe-018',
    name: 'Kedai Kopi Tuku Malang',
    area: 'Lowokwaru',
    address: 'Jl. Tlogomas No. 8, Tlogomas, Lowokwaru',
    lat: -7.9460,
    lng: 112.6090,
    rating: 4.6,
    reviewCount: 312,
    priceMin: 28000,
    priceMax: 75000,
    openTime: '07:00',
    closeTime: '22:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=800&q=80',
      'https://images.unsplash.com/photo-1442512595331-e89e73853f31?w=800&q=80',
    ],
    vibeTags: ['Susu Kopi', 'Signature', 'Tenang', 'Cozy'],
    wifi: true,
    wifiSpeed: 'Kencang',
    outlet: true,
    parking: false,
    noiseLevel: 'Tenang',
    petFriendly: false,
    coffeeType: 'Kopi Susu',
    ratingKopi: 4.8,
    ratingAtmosfer: 4.6,
    ratingWifi: 4.5,
    ratingWFH: 4.4,
    ratingEstetik: 4.5,
    description: 'Brand kopi susu iconic dari Jakarta kini hadir di Malang. Kopi susu kental-nya legend banget.',
  },
  {
    id: 'cafe-019',
    name: 'Lain Hati Kedungkandang',
    area: 'Kedungkandang',
    address: 'Jl. Mayjen Sungkono No. 12, Kedungkandang',
    lat: -8.0150,
    lng: 112.6650,
    rating: 4.2,
    reviewCount: 87,
    priceMin: 15000,
    priceMax: 45000,
    openTime: '08:00',
    closeTime: '22:00',
    isOpen: false,
    photos: [
      'https://images.unsplash.com/photo-1525610553991-2bede1a236e2?w=800&q=80',
      'https://images.unsplash.com/photo-1530026186672-2cd00ffc50fe?w=800&q=80',
    ],
    vibeTags: ['Budget', 'Santai', 'Local', 'Hangout'],
    wifi: true,
    wifiSpeed: 'Sedang',
    outlet: false,
    parking: true,
    noiseLevel: 'Sedang',
    petFriendly: false,
    coffeeType: 'Espresso Based',
    ratingKopi: 4.1,
    ratingAtmosfer: 4.0,
    ratingWifi: 3.6,
    ratingWFH: 3.3,
    ratingEstetik: 4.0,
    description: 'Cafe budget-friendly di area Kedungkandang. Suasana santai, cocok buat nongkrong bareng teman.',
  },
  {
    id: 'cafe-020',
    name: 'Kopi Luwak Batu',
    area: 'Batu',
    address: 'Jl. Diponegoro No. 3, Sisir, Kota Batu',
    lat: -7.8710,
    lng: 112.5240,
    rating: 4.4,
    reviewCount: 156,
    priceMin: 35000,
    priceMax: 150000,
    openTime: '08:00',
    closeTime: '21:00',
    isOpen: true,
    photos: [
      'https://images.unsplash.com/photo-1453614512568-c4024d13c247?w=800&q=80',
      'https://images.unsplash.com/photo-1516997121675-4c2d1684aa3e?w=800&q=80',
    ],
    vibeTags: ['Kopi Luwak', 'Premium', 'Wisata', 'Unik'],
    wifi: true,
    wifiSpeed: 'Sedang',
    outlet: true,
    parking: true,
    noiseLevel: 'Tenang',
    petFriendly: true,
    coffeeType: 'Kopi Luwak',
    ratingKopi: 4.7,
    ratingAtmosfer: 4.5,
    ratingWifi: 3.7,
    ratingWFH: 3.5,
    ratingEstetik: 4.4,
    description: 'Pengalaman minum kopi luwak asli di Batu. Cocok buat wisata kuliner dan oleh-oleh kopi premium.',
  },
];

export const MOCK_REVIEWS = [
  {
    id: 'review-001',
    userId: 'user-001',
    userName: 'Rara Putri',
    userAvatar: 'https://i.pravatar.cc/150?img=47',
    userBadge: true,
    cafeId: 'cafe-001',
    cafeName: 'De Bergstad',
    cafeArea: 'Klojen',
    rating: 5.0,
    text: 'Literally tempat paling aesthetic di Malang! Photoboothnya vintage banget, pas banget buat konten. Kopinya juga enak, worth the price!',
    photos: [
      'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=600&q=80',
      'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=600&q=80',
    ],
    tags: ['Aesthetic', 'Photobooth', 'Date Night'],
    likes: 127,
    comments: 23,
    timeAgo: '2 jam lalu',
    isLiked: false,
    isSaved: false,
  },
  {
    id: 'review-002',
    userId: 'user-002',
    userName: 'Bagas Arya',
    userAvatar: 'https://i.pravatar.cc/150?img=12',
    userBadge: false,
    cafeId: 'cafe-002',
    cafeName: 'Cafe Oemah Bapak',
    cafeArea: 'Dau',
    rating: 4.5,
    text: 'WFC paradise! Udah 3 hari kerja di sini terus. WiFi kencang banget, banyak colokan, dan makanannya enak. Highly recommend buat yang butuh tempat kerja nyaman.',
    photos: [
      'https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?w=600&q=80',
    ],
    tags: ['WFH', 'WiFi Kencang', 'Banyak Colokan'],
    likes: 89,
    comments: 15,
    timeAgo: '5 jam lalu',
    isLiked: true,
    isSaved: false,
  },
  {
    id: 'review-003',
    userId: 'user-003',
    userName: 'Nadira Salsabila',
    userAvatar: 'https://i.pravatar.cc/150?img=23',
    userBadge: true,
    cafeId: 'cafe-003',
    cafeName: 'Nukcha Matcha Cafe',
    cafeArea: 'Blimbing',
    rating: 4.8,
    text: 'Matcha latte-nya TERBAIK sejauh ini! Bingsonya juga fresh banget. Interior Korean vibes, cocok banget buat foto-foto. Harganya memang agak premium tapi worth it!',
    photos: [
      'https://images.unsplash.com/photo-1536304993881-ff86e0c9ef82?w=600&q=80',
      'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=600&q=80',
      'https://images.unsplash.com/photo-1464306076886-debca5e8a6b0?w=600&q=80',
    ],
    tags: ['Matcha', 'Korean Vibes', 'Bingsoo'],
    likes: 203,
    comments: 41,
    timeAgo: '1 hari lalu',
    isLiked: false,
    isSaved: true,
  },
  {
    id: 'review-004',
    userId: 'user-004',
    userName: 'Dimas Pratama',
    userAvatar: 'https://i.pravatar.cc/150?img=33',
    userBadge: false,
    cafeId: 'cafe-005',
    cafeName: 'Zumma Coffee',
    cafeArea: 'Pakis',
    rating: 4.9,
    text: 'Hidden gem paling epic! Ga nyangka ada cafe yang bisa berkuda sekalian ngopi. Kopinya roasting sendiri, fresh banget. Playgroundnya seru buat bawa anak-anak.',
    photos: [
      'https://images.unsplash.com/photo-1445116572660-236099ec97a0?w=600&q=80',
      'https://images.unsplash.com/photo-1565299507177-b0ac66763828?w=600&q=80',
    ],
    tags: ['Hidden Gem', 'Unik', 'Berkuda', 'Family'],
    likes: 445,
    comments: 67,
    timeAgo: '2 hari lalu',
    isLiked: false,
    isSaved: false,
  },
  {
    id: 'review-005',
    userId: 'user-005',
    userName: 'Fiona Maharani',
    userAvatar: 'https://i.pravatar.cc/150?img=56',
    userBadge: true,
    cafeId: 'cafe-008',
    cafeName: 'Kismo Coffee House',
    cafeArea: 'Lowokwaru',
    rating: 4.7,
    text: 'Ambiance-nya premium banget, berasa lagi di cafe luar negeri. Kopi specialty-nya kompleks tapi enak, baristanya helpful banget jelasin menu. Jadi langganan!',
    photos: [
      'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=600&q=80',
    ],
    tags: ['Premium', 'Specialty Coffee', 'Cozy'],
    likes: 156,
    comments: 28,
    timeAgo: '3 hari lalu',
    isLiked: true,
    isSaved: true,
  },
  {
    id: 'review-006',
    userId: 'user-006',
    userName: 'Rizky Firmansyah',
    userAvatar: 'https://i.pravatar.cc/150?img=68',
    userBadge: false,
    cafeId: 'cafe-004',
    cafeName: 'Zocco Heritage Coffee',
    cafeArea: 'Klojen',
    rating: 4.5,
    text: 'Vibesnya heritage banget! Koleksi kopi dari seluruh Indonesia keren. Smoothies bowl-nya fresh dan enak. Parkir gampang, cocok buat nongkrong santai.',
    photos: [
      'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=600&q=80',
    ],
    tags: ['Heritage', 'Smoothies Bowl', 'Santai'],
    likes: 78,
    comments: 12,
    timeAgo: '4 hari lalu',
    isLiked: false,
    isSaved: false,
  },
  {
    id: 'review-007',
    userId: 'user-007',
    userName: 'Ayu Lestari',
    userAvatar: 'https://i.pravatar.cc/150?img=41',
    userBadge: true,
    cafeId: 'cafe-006',
    cafeName: 'Croco by Monsieur Spoon',
    cafeArea: 'Blimbing',
    rating: 4.6,
    text: 'Remote worker paradise! Colokan ada di mana-mana, WiFi stabil buat video call, dan croissant-nya LEGIT. Suasana modern, ga bising. Recommended banget!',
    photos: [
      'https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?w=600&q=80',
      'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=600&q=80',
    ],
    tags: ['WFH', 'Pastry', 'Colokan Banyak'],
    likes: 234,
    comments: 35,
    timeAgo: '5 hari lalu',
    isLiked: false,
    isSaved: false,
  },
  {
    id: 'review-008',
    userId: 'user-008',
    userName: 'Hendra Wijaya',
    userAvatar: 'https://i.pravatar.cc/150?img=15',
    userBadge: false,
    cafeId: 'cafe-012',
    cafeName: 'Anomali Coffee Malang',
    cafeArea: 'Klojen',
    rating: 4.8,
    text: 'Single origin Flores-nya outstanding! Baristanya ngerti banget kopi dan mau jelasin flavor notes-nya. Tempat tenang buat WFH juga. Harga worth it banget.',
    photos: [
      'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=600&q=80',
    ],
    tags: ['Single Origin', 'Specialty', 'Barista Expert'],
    likes: 112,
    comments: 19,
    timeAgo: '1 minggu lalu',
    isLiked: true,
    isSaved: false,
  },
];

export const MOCK_NONGKRONG_EVENTS = [
  {
    id: 'event-001',
    cafeId: 'cafe-001',
    title: 'Ngerjain Skripsi Bareng!',
    description: 'Lagi struggle sama skripsi? Yuk ngerjain bareng di De Bergstad! Bisa saling semangatin dan sharing tips.',
    scheduledTime: 'Sabtu, 20 Sep 2026 · 14:00',
    createdBy: 'Rara Putri',
    creatorAvatar: 'https://i.pravatar.cc/150?img=47',
    participants: 8,
    maxParticipants: 15,
    tags: ['Skripsi', 'WFH', 'Belajar'],
  },
  {
    id: 'event-002',
    cafeId: 'cafe-001',
    title: 'Photography Walk ☕📸',
    description: 'Street photography + ngopi cantik di De Bergstad. Bawa kamera atau HP, kita eksplorasi sudut-sudut kece!',
    scheduledTime: 'Minggu, 21 Sep 2026 · 10:00',
    createdBy: 'Bagas Arya',
    creatorAvatar: 'https://i.pravatar.cc/150?img=12',
    participants: 12,
    maxParticipants: 20,
    tags: ['Fotografi', 'Hangout', 'Seru'],
  },
  {
    id: 'event-003',
    cafeId: 'cafe-001',
    title: 'Kopi & Ngobrol Startup',
    description: 'Buat yang lagi build startup atau tertarik dunia startup, yuk ngumpul dan sharing bareng! Siapa tau ada yang bisa collab.',
    scheduledTime: 'Rabu, 24 Sep 2026 · 19:00',
    createdBy: 'Dimas Pratama',
    creatorAvatar: 'https://i.pravatar.cc/150?img=33',
    participants: 5,
    maxParticipants: 12,
    tags: ['Startup', 'Networking', 'Diskusi'],
  },
];

export const VIBE_FILTERS = [
  { id: 'wfh', label: 'WFH', emoji: '💻' },
  { id: 'hangout', label: 'Hangout', emoji: '🫂' },
  { id: 'hidden-gem', label: 'Hidden Gem', emoji: '💎' },
  { id: 'outdoor', label: 'Outdoor', emoji: '🌿' },
  { id: 'quiet', label: 'Tenang', emoji: '🤫' },
  { id: 'aesthetic', label: 'Aesthetic', emoji: '📸' },
  { id: 'budget', label: 'Budget', emoji: '💰' },
  { id: 'premium', label: 'Premium', emoji: '✨' },
  { id: 'pet-friendly', label: 'Pet Friendly', emoji: '🐾' },
  { id: 'open-late', label: 'Buka Malam', emoji: '🌙' },
];

export const MALANG_AREAS = [
  'Semua', 'Klojen', 'Lowokwaru', 'Blimbing', 'Sukun', 'Kedungkandang', 'Dau', 'Pakis', 'Batu', 'Singosari', 'Lawang',
];